// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"011b73f0","707":"3424a9dc","729":"9d42ebb8"}[chunkId] + ".js";
};